import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("main", {
    staticClass: "spacing-form"
  }, [_c("a-form", {
    attrs: {
      form: _vm.form
    }
  }, [_c("CardItem", {
    attrs: {
      title: _vm.$t("form.location"),
      layout: "vertical"
    }
  }, [_c("a-select", {
    attrs: {
      mode: "multiple",
      placeholder: _vm.$t("form.placeSelectLocation")
    },
    model: {
      value: _vm.value.location,
      callback: function callback($$v) {
        _vm.$set(_vm.value, "location", $$v);
      },
      expression: "value.location"
    }
  }, _vm._l(_vm.locationClient, function (item, i) {
    return _c("a-select-option", {
      key: i,
      attrs: {
        value: item.value
      }
    }, [_vm._v(" " + _vm._s(item.label) + " ")]);
  }), 1)], 1), _c("CardItem", {
    attrs: {
      title: _vm.$t("form.bgColor")
    }
  }, [_c("ColorPicker", {
    model: {
      value: _vm.value.bgColor,
      callback: function callback($$v) {
        _vm.$set(_vm.value, "bgColor", $$v);
      },
      expression: "value.bgColor"
    }
  })], 1), _c("CardItem", {
    class: {
      "location-disabled": !_vm.value.location.includes(1)
    },
    attrs: {
      title: _vm.$t("form.pcSpacingHeight"),
      layout: "vertical"
    }
  }, [_c("InputBar", {
    attrs: {
      min: 1,
      max: 200,
      suffix: "px"
    },
    model: {
      value: _vm.value.pcHeight,
      callback: function callback($$v) {
        _vm.$set(_vm.value, "pcHeight", $$v);
      },
      expression: "value.pcHeight"
    }
  })], 1), _c("CardItem", {
    class: {
      "location-disabled": !_vm.value.location.includes(2)
    },
    attrs: {
      title: _vm.$t("form.mSpacingHeight"),
      layout: "vertical"
    }
  }, [_c("InputBar", {
    attrs: {
      min: 1,
      max: 200,
      suffix: "px"
    },
    model: {
      value: _vm.value.mHeight,
      callback: function callback($$v) {
        _vm.$set(_vm.value, "mHeight", $$v);
      },
      expression: "value.mHeight"
    }
  })], 1)], 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };